import type { PopoverState } from 'react-tiny-popover';
import { preferredSide, verticalBudgets } from './verticalPlacement';

/**
 * Height budget for a popover anchored to `childRect`, so its content can
 * scroll instead of overflowing the viewport.
 *
 * Three constraints shape this. `position` and `popoverRect` are ignored
 * because both are measured *from* the content, so feeding either back into the
 * content's height makes the library re-measure, re-position and re-render
 * without end. The budget is the space *below* the anchor even though the
 * library may flip the popover above it: below is the fallback placement, so a
 * box that fits there fits whichever side the library settles on, whereas
 * budgeting the roomier side overflows when the library keeps its first choice.
 * When the space below is too small to use, the budget is the space above,
 * which the library then flips to, since a box that tall cannot fit below. The
 * edge gap also absorbs the dropdown's own `mt-2` offset when it opens downwards.
 */
export function popoverMaxHeight({
  childRect,
  boundaryRect,
  boundaryInset,
  padding,
}: PopoverState): number {
  const budgets = verticalBudgets(
    childRect,
    boundaryRect,
    padding + boundaryInset
  );
  return Math.max(budgets[preferredSide(budgets)], 0);
}
